export default "__VITE_ASSET__BllX$68Q__"